import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DialogState } from 'shared/domains/common-ui/DialogState';
import { useDownloadCSV } from './useDownloadCSV';
export function CSVDownload() {
    const { download, loading, progress, cancel } = useDownloadCSV();
    return (<Fragment>
      <DialogState onClose={cancel} state={{ loading }} loading={{
            title: t({
                message: `Downloading ${progress}%`,
                comment: 'Title on status dialog when downloading search result',
            }),
            description: t({
                message: 'Wait while we download the data for you.',
                comment: 'Description on status dialog when downloading search result',
            }),
            actions: (<Button type="button" appearance="secondary" onClick={cancel} size="xs">
              <Trans comment="Cancel search result CSV download">Cancel</Trans>
            </Button>),
        }}/>
      <Button type="button" size="xs" onClick={download} disabled={loading} appearance="secondary">
        {loading ? <Loader /> : <Falcon icon="download"/>}
        <Trans comment="CSV download button: Label">Download</Trans>
      </Button>
    </Fragment>);
}
